<div class="selected-slot-container">
    <div class="selected-slot-title">
        <div *ngFor="let title of getSlotTileArray()">{{ title }}</div>
        <div class="slot-info"></div>
        <div class="terminals-info">
            {{ getActiveTerminalsText() }}
        </div>
    </div>

    <div class="save-container">
        <div class="button cancel" (click)="cancel()">
            {{ 'output-settings.AO.cancel-button' | translate }}
        </div>
        <div class="button save" [class.saveDisabled]="!isSaveEnabled()" (click)="save()">
            {{ 'output-settings.AO.save-button' | translate }}
        </div>
    </div>
</div>

<div class="body-container">
    <ng-container *ngIf="!isLoadingTerminals; else terminalsSpinner">
        <div class="analog-row table-header">
            <div class="column terminal-no">
                {{ 'output-settings.AO.header.terminal' | translate }}
            </div>
            <div class="column status">
                {{ 'output-settings.AO.header.status' | translate }}
            </div>
            <div class="column channel">
                {{ 'output-settings.AO.header.channel' | translate }}
            </div>
            <div class="column col-options">
                <mat-icon
                    svgIcon="more-options"
                    class="icon"
                    style="cursor: pointer"
                    (click)="showOptions = !showOptions; $event.stopPropagation()" />
                <div class="options-container" *ngIf="showOptions">
                    <div class="option-row">
                        <mat-icon svgIcon="delete" class="small-icon" />
                        <div (click)="deleteAllChannels()">
                            {{ 'output-settings.AO.table.delete-all' | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngFor="let setting of outputSettings" class="analog-row">
            <div class="column terminal-no semibold">
                {{ setting.terminalNum }}
            </div>
            <div
                class="column status"
                [class.errorStatus]="settingsErrorSet.has(setting.terminalNum)"
                [class.emptyStatus]="!settingsErrorSet.has(setting.terminalNum) && !setting.channels[0]">
                {{ getStatusString(setting) | translate }}
            </div>
            <div class="column channel">
                <ng-container *ngIf="setting.channels[0]; else channelInput">
                    <div class="selected-channel-wrapper">
                        <div class="channel-name-wrapper">
                            {{ getChannelName(setting.channels[0]) }}
                        </div>
                        <div class="channel-remove-wrapper" (click)="removeChannel(setting)">
                            <mat-icon svgIcon="delete" class="icon" />
                            <div>
                                {{ 'output-settings.AO.table.channel.clear' | translate }}
                            </div>
                        </div>
                    </div>
                </ng-container>
                <ng-template #channelInput>
                    <app-channel-search-input
                        style="width: 100%"
                        [channels]="channels"
                        [selectedChannel]="setting?.channels?.[0]"
                        (onChannelSelected)="handleChannelSelected($event, setting)"
                        (onChannelHasError)="handleSettingError($event, setting)"></app-channel-search-input>
                </ng-template>
            </div>
            <div class="column col-options" style="padding: 8px">
                <ng-container *ngIf="!settingsErrorSet.has(setting.terminalNum); else errorIcon">
                    <mat-icon svgIcon="check-circle" class="icon" [class.disabled]="!setting.channels?.[0]" />
                </ng-container>
                <ng-template #errorIcon>
                    <div class="error-icon-container">
                        <mat-icon
                            svgIcon="save-error"
                            (click)="
                                isErrorMessageVisible = isErrorMessageVisible ? null : setting; $event.stopPropagation()
                            " />
                        <div class="info-message-container" *ngIf="isErrorMessageVisible == setting">
                            {{ 'output-settings.AO.table.error.message' | translate }}
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </ng-container>
</div>

<ng-template #terminalsSpinner>
    <app-loading-spinner class="terminals-spinner" strokeWidth="2"></app-loading-spinner>
</ng-template>
